import { Link } from 'react-router-dom';
import { SEOHead } from '../../components/seo/SEOHead';
import { useOrders } from '../../hooks/useOrders';
import { OrderCard } from '../../components/dashboard/OrderCard';
import { Spinner } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';

export default function MyOrders() {
  const { orders, isLoading } = useOrders();

  return (
    <>
      <SEOHead title="My Orders — Bharat Consultancy" description="" canonicalPath="/dashboard/orders" />

      <h1 className="font-display text-2xl font-bold text-ink">My Orders</h1>

      <div className="mt-6 space-y-3">
        {isLoading ? (
          <Spinner className="h-6 w-6 text-seal-blue" />
        ) : orders.length === 0 ? (
          <div className="rounded-lg border border-dashed border-line p-8 text-center">
            <p className="text-ink/60">You haven't placed any orders yet.</p>
            <Link to="/services" className="mt-4 inline-block">
              <Button size="sm">Browse Services</Button>
            </Link>
          </div>
        ) : (
          orders.map((order) => <OrderCard key={order.id} order={order} />)
        )}
      </div>
    </>
  );
}
